import { createSelector } from 'reselect';


/**
 * Description of the selectedAuthUserPreferences selector
 *
 * @param {Object} state - The redux store to pull data from
 */
export const selectedAuthUserPreferences = createSelector(
  [
    (state) => state.preferences.allPreferences,
    (state) => state.user.preferences,
  ],
  (allPreferences, preferences) => {
    return allPreferences.map((preference) => {
      return {
        id: preference.id,
        subscription_type: preference.subscription_type,
        subscribed: preferences.includes(preference.id),
      };
    });
  },
);

export default selectedAuthUserPreferences;
